import { ClipboardList, Search, FileCheck2 } from "lucide-react";

const STEPS = [
  {
    Icon: ClipboardList,
    title: "Tell us about you",
    body: "Answer a short, friendly questionnaire. About 5 minutes—no SSN required to get a quote.",
  },
  {
    Icon: Search,
    title: "We shop 20+ carriers",
    body: "Darryl independently compares top-rated insurers to find the strongest fit for your needs and budget.",
  },
  {
    Icon: FileCheck2,
    title: "You decide, we handle the rest",
    body: "Review options on a call, then we walk you through underwriting and policy delivery start to finish.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-24 sm:py-32 bg-pp-bone"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-pp-forest">
              How it works
            </span>
            <h2 className="mt-4 font-serif font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight text-pp-forest-deep leading-[1.05]">
              A clearer path to coverage.
            </h2>
            <p className="mt-6 text-lg text-pp-text-secondary leading-relaxed">
              No call centers. No spam. Just one broker, working for you, end
              to end.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-6">
            {STEPS.map((s, i) => (
              <div
                key={s.title}
                data-testid={`how-step-${i + 1}`}
                className="bg-white border border-pp-border-subtle rounded-2xl p-8 flex gap-6 transition-all hover:-translate-y-0.5 hover:shadow-[0_12px_32px_rgba(26,46,38,0.05)]"
              >
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 rounded-full bg-pp-cream flex items-center justify-center">
                    <s.Icon className="w-6 h-6 text-pp-forest stroke-[1.5]" />
                  </div>
                </div>
                <div>
                  <div className="text-xs text-pp-terracotta font-bold tracking-wider mb-1">
                    STEP {i + 1}
                  </div>
                  <h3 className="font-serif text-2xl text-pp-forest-deep mb-2">
                    {s.title}
                  </h3>
                  <p className="text-pp-text-secondary leading-relaxed">
                    {s.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
